export enum FinesRoleEnum {
    TITULAR = 'TITULAR',
    OFFENDER = 'OFFENDER',
    IDENTIFICATION = 'IDENTIFICATION',
}
